export const APP_NAME = 'dealershipPicker';
